import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { formatTipoArticolo } from "../../../api/articoliEvento";

const getArticleName = (article) => article.nomeArticolo || article.name || "";

export const filterArticoliEvento = (options, state) => {
  const query = state.inputValue.toLowerCase();
  if (!query) return options;

  return options.filter((article) =>
    [article.sku, getArticleName(article), formatTipoArticolo(article.tipoArticolo)]
      .join(" ")
      .toLowerCase()
      .includes(query)
  );
};

const ArticoloEventoPicker = ({ options, value, onChange }) => (
  <Autocomplete
    options={options}
    value={value}
    onChange={(event, article) => onChange(article)}
    getOptionLabel={(article) => (article ? getArticleName(article) : "")}
    getOptionSelected={(option, selected) =>
      option.sku === selected.sku && option.tipoArticolo === selected.tipoArticolo
    }
    filterOptions={filterArticoliEvento}
    renderOption={(article) => {
      const hasImage = article.image && article.image !== "0";
      return (
        <div className="d-flex align-items-center">
          {hasImage ? (
            <img
              src={toAbsoluteUrl(article.image, article.division)}
              alt=""
              style={{ width: 40, height: 40, objectFit: "contain", marginRight: 12, flexShrink: 0 }}
            />
          ) : (
            <span
              aria-label="Immagine non disponibile"
              className="bg-light rounded mr-3"
              style={{ width: 40, height: 40, flexShrink: 0 }}
            />
          )}
          <span className="d-flex flex-column">
            <small>{article.sku}</small>
            <span>{getArticleName(article)} <small>{article.qta}</small></span>
            <small className="text-muted">{formatTipoArticolo(article.tipoArticolo)}</small>
          </span>
        </div>
      );
    }}
    renderInput={(params) => <TextField {...params} placeholder="Seleziona articolo..." variant="outlined" size="small" />}
  />
);

export default ArticoloEventoPicker;
